import { render, staticRenderFns } from "./resultInformation.vue?vue&type=template&id=238fde2e&"
import script from "./resultInformation.vue?vue&type=script&lang=js&"
export * from "./resultInformation.vue?vue&type=script&lang=js&"
import style0 from "./resultInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports